
import { defineComponent } from 'vue'
import useBar from './useBar'

export default defineComponent({
  name: 'Bar',
  props: {
    vertical: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    size: String,
    // eslint-disable-next-line vue/require-default-prop
    move: Number
  },
  setup (props) {
    const {
      instance,
      thumb,
      bar,
      clickTrackHandler,
      clickThumbHandler,
      thumbStyle,
      visible
    } = useBar(props)

    return {
      instance,
      thumb,
      bar,
      clickTrackHandler,
      clickThumbHandler,
      thumbStyle,
      visible
    }
  }
})

